import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateLectureQuizOption as updateLectureQuizOptionApi } from "../../../../services/dashboard/apiQuizes";

export function useUpdateQuizOption() {
  const queryClient = useQueryClient();

  const {
    mutate: updateQuizOption,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateLectureQuizOptionApi,
    onSuccess: () => {
      toast.success("تم تعديل الأختيار بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["quizOptionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateQuizOption, isUpdating, error };
}
